@if(iterations.length > 1){
  <div class="row">
    <div class="col-12">
      <label class="iteration-label">{{ 'i18n.domain.import-protocol.log-list.iterationLabel' | translate}}:&nbsp;</label>
      <label><b>{{iteration}}</b>.&nbsp;&nbsp;</label>
      <label for="iterations" class="iteration-label">{{ 'i18n.domain.import-protocol.log-list.iteration-dropdown-label' | translate}}:</label>
      <select #ddIteration (change)="onIterationChanged(ddIteration.value)" class="iteration-dropdown" [value]='iteration'>
        @for (i of iterations; track i) {
          <option>{{i}}</option>
        }
      </select>
    </div>
  </div>
}
<div class="row">
  <div class="col-12">
    <ejs-grid #grid rowHeight="38" class="grid-with-toolbar grid-configuration" [dataSource]="logEntries"
      [allowSorting]="true" [allowPaging]="false" [allowFiltering]="true" [filterSettings]="filterSettings">
      <e-columns>
        <e-column field="entryIdent"
          headerText="{{'i18n.domain.import-protocol.log-list.fields.entryIdent' | translate}}"
          clipMode="EllipsisWithTooltip" width="200px"></e-column>
        <e-column field="logStatus" [filter]="successStateFilter"
          headerText="{{'i18n.domain.import-protocol.log-list.fields.logStatus' | translate}}"
          clipMode="EllipsisWithTooltip" width="150px">
          <ng-template #filterItemTemplate let-data>
            {{'i18n.domain.import-configuration.enums.success-state.' + LogStatus[data.logStatus] | translate}}
          </ng-template>
          <ng-template #template let-data>
            {{ getState(data) | translate}}
          </ng-template>
        </e-column>
        <e-column field="statusMessage"
          headerText="{{'i18n.domain.import-protocol.log-list.fields.statusMessage' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            <ejs-tooltip id="tooltipClick" opensOn='Auto' width='50%'>
              <ng-template #content>
                <div [innerHTML]="extractJsonMessage(data.statusMessage, false, 0)">
                </div>
              </ng-template>
              <div>
                {{extractJsonMessage(data.statusMessage, true, 400)}}
              </div>
            </ejs-tooltip>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
